import React, { CSSProperties, useCallback } from 'react';
import { List } from 'antd';
import YListItem from '../../../../components/global/data-display/YListItem';
import { COLORS } from '@ydistri/theme';
import AdministrationItemLink from '../AdministrationItemLink';
import AdministrationItemCard from '../AdministrationItemCard';
import type { AdministrationItemCardProps } from '../AdministrationItemCard';

export interface AdministrationItemsListItemProps {
  recordId: string | number;
  link: string;
  selected?: boolean;
  isArchived?: boolean;
  cardProps: AdministrationItemCardProps;
}

interface AdministrationItemsListProps<T> {
  data?: T[];
  loading?: boolean;
  getItemProps: (item: T) => AdministrationItemsListItemProps;
  $width?: CSSProperties['width'];
}

const AdministrationItemsList = <T,>({
  data,
  loading,
  getItemProps,
  $width,
  ...rest
}: AdministrationItemsListProps<T>): React.ReactElement => {
  const renderItem = useCallback(
    (item: T) => {
      const {
        recordId,
        link,
        selected = false,
        isArchived = false,
        cardProps,
      } = getItemProps(item);

      return (
        <YListItem
          selected={selected}
          $backgroundColor={isArchived ? COLORS.GREY_LIGHT : undefined}
          data-recordid={recordId}
          $width={$width}
        >
          <AdministrationItemLink to={link}>
            <AdministrationItemCard $minNameWidth="17rem" {...cardProps} />
          </AdministrationItemLink>
        </YListItem>
      );
    },
    [getItemProps, $width],
  );

  return (
    <List dataSource={data} loading={loading} size="small" renderItem={renderItem} {...rest} />
  );
};

export default AdministrationItemsList;
